import mergeDeep from '@/utils/merge-deep';
import { SectionOneColumnThemeControls } from '@/components/organisms/SectionOneColumn/theming';

import block from './block.json';

export const SectionCardsPartnerThemeAttributes = {
	title: {
		color: '@tokens.variants.default.contentColor',
		typography: '@tokens.typographies.heading-2',
		textAlignment: 'left',
	},
};

export const SectionCardsPartnerThemeControls: ThemeControlsType = mergeDeep(
	SectionOneColumnThemeControls,
	{
		// What's displayed
		title: block.title,

		// Unique string/id of the block (= the key used in theme.json)
		slug: block.slug,

		// styling attributes available for this block
		// ...the same way we define attributes for a gutenberg block
		attributes: SectionCardsPartnerThemeAttributes,
	}
);
